export default __webpack_public_path__ + "static/media/winequality.15ac2d86.jpg";